//CONFIRMATION MODAL
export const CONFIRMATION_MODAL_TITLE = "Are you sure?";

// PAGINATION
export const DEFAULT_STARTING_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_PAGE_SIZE_OPTIONS = [
  {
    value: 10,
    label: "10 / page",
  },
  {
    value: 20,
    label: "20 / page",
  },
  {
    value: 50,
    label: "50 / page",
  },
  {
    value: 100,
    label: "100 / page",
  },
];

// REGIONS
export const REGION_SCOTLAND = 1;
export const REGION_NW_MIDLANDS = 2;
export const REGION_SW_WALES = 3;
export const REGION_N_LONDON_HOME_COUNTIES = 4;
export const REGION_S_LONDON_SE = 5;
export const REGION_IRELAND = 6;
export const REGION_NATIONALS = 7;
export const REGION_ALL = 8;

export const REGION_OPTIONS = [
  { value: 1, label: "Area 1 Scotland" },
  { value: 2, label: "Area 2 NW & Midlands" },
  { value: 3, label: "Area 3 SW & Wales" },
  { value: 4, label: "Area 4 N London and Home Counties" },
  { value: 5, label: "Area 5 S London and SE" },
  { value: 6, label: "Area 6 Ireland" },
  { value: 7, label: "Area 7 Nationals" },
  { value: 8, label: "All Regions" },
];

export const REGION_FILTERS_OPTIONS = [
  { value: 1, label: "Area 1 Scotland" },
  { value: 2, label: "Area 2 NW & Midlands" },
  { value: 3, label: "Area 3 SW & Wales" },
  { value: 4, label: "Area 4 N London and Home Counties" },
  { value: 5, label: "Area 5 S London and SE" },
  { value: 6, label: "Area 6 Ireland" },
  { value: 7, label: "Area 7 Nationals" },
];

export const PROJECT_TYPE_OPTIONS = [
  { label: "New Build Private", value: 1 },
  { label: "New Build Public", value: 2 },
  { label: "Private Repair/Maintenance", value: 3 },
  { label: "Public Repair/Maintenance", value: 4 },
  { label: "Commercial", value: 5 },
];